import React from 'react';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import styleUtils from 'src/utils/styles';
import Button from '../button/Button';
import ColumnCenter from '../layout/ColumnCenter';
import Row from '../layout/Row';
import Typography from '../typography/Typography';
const ScreenErrorFallback = ({ onRetry, onGoBack, message = 'Something went wrong on this page.', }) => {
    const [{ theme, styles }] = useTheme(stylesGenerator);
    return (React.createElement(ColumnCenter, { flex: true, bg: theme.palette.background.main, style: [styles.container, styleUtils.pagePadding], spacing: theme.spacing.standard.md },
        React.createElement(Typography, { align: "center", variant: TypographyVariant.BODY }, message),
        React.createElement(Row, { spacing: theme.spacing.standard.sm },
            React.createElement(Button, { variant: "text", onPress: onRetry }, "Retry"),
            onGoBack ? (React.createElement(Button, { variant: "text", onPress: onGoBack }, "Go back")) : null)));
};
const stylesGenerator = createThemedStyle(() => ({
    container: {
        paddingVertical: 48,
    },
}));
export default ScreenErrorFallback;
